import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    CellRunner,
    JockeyAndTrainerDetailsBox,
    RaceResultsRowCaption,
    ResultCell,
    ResultSelectionCell,
    SilkCellRaceSummaryWrapper,
} from 'src/domains/sportsbook/webview/components/raceCard/raceResults/horseRacing/RaceResultsRow.style';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface RaceResultsRowPropsType {
    selectionId: SelectionId;
}

export const RaceResultsRow = observer('RaceResultsRow', (props: RaceResultsRowPropsType) => {
    const { selectionId } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { sportsbookVariant } = configState.componentVariants;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const isUnnamedFavourite = selectionModel.templateId === 'unnamed-favourite';
    if (isUnnamedFavourite) {
        return null;
    }

    const selectionResult = selectionModel.resultPlace === null ? 1 : selectionModel.resultPlace;
    const selectionSp = selectionModel.spPrice === null ? '-' : selectionModel.spPrice.f;

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <RaceResultsRowCaption variant={sportsbookVariant}>
            <ResultCell>{selectionResult}</ResultCell>

            <CellRunner>
                <SilkCellRaceSummaryWrapper>
                    <LazyImageSilk
                        imgBase={{
                            src: silkUrl,
                            optimizeOptions: {
                                quality: 85,
                                width: 54,
                            },
                        }}
                        alt={silkAltDesc}
                    />
                </SilkCellRaceSummaryWrapper>

                <JockeyAndTrainerDetailsBox
                    selectionId={selectionId}
                    isDetailsAvailable={true}
                />
            </CellRunner>

            <ResultSelectionCell>{selectionSp}</ResultSelectionCell>
        </RaceResultsRowCaption>
    );
});
